/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContainerInfo = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        image: {
            type: 'string',
            isRequired: true,
        },
        ready: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
